/**
 * Share dossier addresses (`/paylasim/<token>`) carry a bearer token: whoever holds the address can
 * open the dossier. Analytics and attribution record the route pattern instead of the token.
 */
const SHARE_PATH = /^\/paylasim\/[^/?#]+\/?/;

export function redactPrivatePath(pathname: string): string {
  return pathname.replace(SHARE_PATH, '/paylasim/:token');
}

/** The same rule for an absolute address such as `window.location.href`: only the path changes. */
export function redactPrivateUrl(href: string): string {
  const url = new URL(href);
  const pathname = redactPrivatePath(url.pathname);
  return pathname === url.pathname ? href : `${url.origin}${pathname}${url.search}${url.hash}`;
}
